export default __webpack_public_path__ + "static/media/peccdk_logo.2d2c8ba3.jpg";